// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__MJvdO","highlight":"Tag_highlight__rokYb","grey":"Tag_grey__HNjs0","dark":"Tag_dark__EUQGb","disabled":"Tag_disabled__cYGAv"};